'use client';

import { useEffect } from 'react';

import { uiStore } from '@stores/ui';

import './snack-bar.css';

const alertTypes: {
    primary: { className: string; icon: string };
    success: { className: string; icon: string };
    warning: { className: string; icon: string };
    info: { className: string; icon: string };
} = {
    primary: { className: 'filledPrimary', icon: 'tri-ui-bell' },
    success: { className: 'filledSuccess', icon: 'tri-ui-check-r' },
    warning: { className: 'filledWarning', icon: '' },
    info: { className: 'filledInfo', icon: 'tri-exclamation-circle' },
};

function Snackbar() {
    const { snackbar, hideSnackbar } = uiStore();

    useEffect(() => {
        if (snackbar.show) {
            autoClose();
        }
    }, [snackbar.show]);

    const handleCloseSnackbar = () => {
        setTimeout(() => hideSnackbar(), 100);
    };

    const autoClose = () => {
        setTimeout(() => {
            hideSnackbar();
        }, snackbar.autoHideDuration);
    };

    if (!snackbar.show || !snackbar.alertType) return null;

    return (
        <>
            <div className='MuiSnackbarRoot' onClick={() => handleCloseSnackbar()}>
                <div className={`MuiAlertRoot ${'MuiAlert-' + (alertTypes[snackbar.alertType]?.className || '')}`}>
                    <div className='MuiAlertIcon'>
                        <span className='icon is-small'>
                            {alertTypes[snackbar.alertType].icon && (
                                <i className={alertTypes[snackbar.alertType].icon}></i>
                            )}
                        </span>
                    </div>
                    <div className='MuiAlertMessage'>{snackbar.message}</div>
                    <div className='MuiAlertAction'>
                        <button className='MuiIconButtonRoot' type='button'>
                            <span>
                                <svg className='MuiSvgIconRoot' viewBox='0 0 24 24'>
                                    <path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'></path>
                                </svg>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Snackbar;
